<template>
  <div class="report">
    <div v-for=" items in list">
      <div class="title">{{items.name}}</div>
      <div class="head"><div>日期:{{items.date}} </div><div>⼊库编号: {{items.move_id}}</div>  </div>
      <table>
        <tr>
          <th colspan="6">1废物⽣产单位: {{items.hospital}}</th>
          <th>2废物转移联单号 {{items.move_id}}</th>
          <th colspan="2">{{items.code}}</th>
        </tr>
        <tr>
          <th>3时间</th>
          <th>4废物编号</th>
          <th>5废物序号</th>
          <th>6废物名称</th>
          <th>7废物物理状态</th>
          <th>8废物存放位置</th>
          <th>9容器材质及容量</th>
          <th>10容器个数</th>
          <th>11废物重量</th>
        </tr>
        <tr v-for="item in items.list">
          <td >{{item[0]}}</td>
          <td>{{item[1]}}</td>
          <td>{{item[2]}}</td>
          <td>{{item[3]}}</td>
          <td>{{item[4]}}</td>
          <td>{{item[5]}}</td>
          <td>{{item[6]}}</td>
          <td>{{item[7]}}</td>
          <td>{{item[8]}}</td>
        </tr>
        <tr><td colspan="10" style="text-align: left;padding-left: 10px">12本批总量: {{items.weight}}</td></tr>
        <tr><td colspan="10" style="text-align: left;padding-left: 10px">废物运输部⻔：{{items.transport}} 废物运输⻋号：{{items.car_no}} 废物运输⼈员：{{items.driver}}  贮存部⻔经⼿⼈（签字） : </td></tr>
      </table>
      <p> </p>
      <p> </p>
      <p> </p>
      <p> </p>
      <p> </p>
      <p> </p>
      <p> </p>
    </div>
  </div>
</template>
<script>
  import Config from "../config.js"
  export default {
    name: "Month",
    data(){
      return {
        list:[
          {date:"",name:"",code:"",list:[[1,2,3,4,5,6,7,8,9]],hospital:"",no:"",}
        ],
        userName:'',
      }
    },
    methods:{
      init(){
        this.userName=this.$route.query.userName;
        this.request(Config.HTTP+"upload?key="+this.$route.query.key,(res)=>{
            this.list=res;

        } )
      },

    },
    mounted(){


    },
    created(){

      this.init()


    }
  }

</script>
<style scoped>
  .report{
    width: 100%;color: #000;}
  .report .title{height:34px;line-height: 30px;font-weight: bold;font-size: 14px;}
  table{
    border-collapse: collapse;
    width: 100%;
  }
  table td{border: 1px solid #000;font-size: 10px;height: 32px;}
  table th{border: 1px solid #000;font-size: 10px;height:32px;}
  .head>div{width: 50%;display: inline-block;text-align: left;font-size: 12px}
  .head>div:last-child{text-align: right;}
</style>



// WEBPACK FOOTER //
// src/view/report/in.vue